"use client"

import { useToast } from "@/hooks/use-toast"
import { X } from "lucide-react"
import { cn } from "@/lib/utils"

export function Toaster() {
    const { toasts, removeToast } = useToast()

    return (
        <div className="fixed top-0 z-[100] flex max-h-screen w-full flex-col-reverse p-4 sm:bottom-0 sm:right-0 sm:top-auto sm:flex-col md:max-w-[420px]">
            {toasts.map((toast) => (
                <div
                    key={toast.id}
                    className={cn(
                        "group pointer-events-auto relative flex w-full items-center justify-between space-x-4 overflow-hidden rounded-md border p-6 pr-8 shadow-lg transition-all mb-2",
                        toast.type === "destructive" && "border-destructive bg-destructive text-destructive-foreground",
                        toast.type === "default" && "border bg-background text-foreground"
                    )}
                >
                    <div className="grid gap-1">
                        <div className="text-sm font-semibold">{toast.title}</div>
                        <div className="text-sm opacity-90">{toast.description}</div>
                    </div>
                    <button
                        onClick={() => removeToast(toast.id)}
                        className="absolute right-2 top-2 rounded-md p-1 text-foreground/50 opacity-0 transition-opacity hover:text-foreground focus:opacity-100 focus:outline-none focus:ring-2 group-hover:opacity-100"
                    >
                        <X className="h-4 w-4" />
                    </button>
                </div>
            ))}
        </div>
    )
}
